<template>
  <resource-collection>
    <template slot-scope="{item}">
      <recurrence :recurrence="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Recurrence from './Recurrence.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Recurrence, ResourceCollection },

  mounted() {
    Event.listen('recurrenceUpdated', recurrence => this.update(recurrence));
    Event.listen('recurrenceCreated', recurrence => this.prepend(recurrence));
    Event.listen('recurrenceDeleted', recurrence => this.remove(recurrence));
  },
};
</script>